import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Spinner } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import ErrorModal from './ErrorModal';
import { getHierarchyLevel } from './HierarchyViewer';

const BoardRoles = () => {
  const [roles, setRoles] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [errors, setErrors] = useState({}); // Error state
  const [apierrors, setApiErrors] = useState('');// Error state
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Lade, bitte warten...');
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setApiErrorCode] = useState('');// Error state


  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filterTerm, setFilterTerm] = useState('');

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Set items per page

  const [formData, setFormData] = useState({
    name: "",
    
  });

  const validateForm = () => {
    const newErrors = {};
  
    // Validate company_name
    if (!formData.name.trim()) {
      newErrors.name = 'Role Name is required';
    }  
    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  
  useEffect(() => {
    validateForm();
  }, [formData]); // This will run every time formData is updated


  useEffect(() => {
    
    UserService.getRolesBoard().then(
      (response) => {
        setRoles(response.data);
       
      }).catch((error) => {
        console.log(error);
        console.log(error.message);
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          console.log(_content);
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 
        setRoles(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});
  }, [deleteState]);
  
 
  


// Filter the mainvos based on the filter input
const filteredMainVOs = Array.isArray(roles)
    ? roles.filter((vo) =>
        (vo.name && vo.name.toLowerCase().includes(filterTerm.toLowerCase())) ||
        (vo.createdAt && vo.createdAt.includes(filterTerm)) ||
        (vo.updatedAt && vo.updatedAt.includes(filterTerm))
      )
    : [];

  
// Get the current page's data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMainVOs = filteredMainVOs.slice(indexOfFirstItem, indexOfLastItem);
 
   // Handle pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Sorting function
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
  

  // Sort the filtered data
  const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
    let aValue;
    let bValue;
    if (sortConfig.key === 'stufe') {
      aValue = getHierarchyLevel(a.name)?.stufe || 0;
      bValue = getHierarchyLevel(b.name)?.stufe || 0;
    } else {
      aValue = a[sortConfig.key];
      bValue = b[sortConfig.key];
    }
    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });


  // Total pages calculation
  const totalPages = Math.ceil(filteredMainVOs.length / itemsPerPage);

  const handleEditClick = (main_vo) => {
    setApiErrors(null);
    setApiErrorCode(null);
    setSelectedRole(main_vo);
    setFormData(main_vo);
    setShowEditModal(true);
  };

  const handleCreateClick = () => {
    setApiErrors(null);
    setApiErrorCode(null);
    setFormData({
      name: "",
      
    });
    setShowCreateModal(true);
  };


  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      setLoadingText('Daten werden gelöscht, bitte warten...');
      setLoading(true);
      await UserService.deleteRolesBoard(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error deleting Roles:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    console.log(selectedRole);
    if (!validateForm()) return; 
    try {
      // formData.rec_date = new Date();
      setLoadingText('Daten werden aktualisiert, bitte warten...');
      setLoading(true);
      await UserService.updateRolesBoard(selectedRole.id,formData);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Role Group:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  


  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      
      setLoadingText('Daten werden erstellt, bitte warten...');
      setLoading(true);
      formData.rec_date = new Date();
      const recDate = formData.rec_date;
      const validDate = isValidDate(recDate) ? recDate : null;     
      //formData.rec_date = validDate;
      await UserService.createRolesBoard(formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Role Group:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
    validateForm();
 };

 const handleChange = (e) => {
   setFormData({
     ...formData,
     [e.target.name]: e.target.value
   });
 validateForm();
 };

 const handleCloseModal = () => setShowModal(false);

  return (
    <Container>
      <h1 className="mt-5">Benutzerrollenübersicht</h1>
                {/* Display error if it exists */}
                <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />

      <Button variant="info" onClick={handleCreateClick} className="mr-2 mb-2">
        Erstellen
      </Button>
      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only">Lade...</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}
      {/* Filter Input */}
      <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Suche nach Rollenname, ID und Datum"
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
        />
      </Form.Group>
      {/* Table */}
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            {/* Sortable column headers */}
            <th onClick={() => handleSort('stufe')} style={{ cursor: 'pointer' }}>
              Stufe {sortConfig.key === 'stufe' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>
              ID {sortConfig.key === 'id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
              Benutzerrollenname {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('createdAt')} style={{ cursor: 'pointer' }}>
              Erstelldatum {sortConfig.key === 'createdAt' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('updatedAt')} style={{ cursor: 'pointer' }}>
              Änderungsdatum {sortConfig.key === 'updatedAt' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
  {sortedMainVOs.map((vo) => (
    <tr key={vo.id}>
      <td>
        {(() => {
          const lvl = getHierarchyLevel(vo.name);
          return lvl ? (
            <span
              className="hv-stufe-badge"
              style={{ backgroundColor: lvl.color }}
              title={lvl.label}
            >
              {lvl.stufe}. Stufe
            </span>
          ) : (
            <span className="text-muted">–</span>
          );
        })()}
      </td>
      <td>{vo.id}</td>
      <td>{vo.name}</td>
      <td style={{ whiteSpace: 'nowrap' }}>{vo.createdAt}</td>
      <td style={{ whiteSpace: 'nowrap' }}>{vo.updatedAt}</td>
      <td>
        {vo.id > 10 ? ( // Show actions only for IDs greater than 10
          <ButtonGroup>
            <Button variant="warning" onClick={() => handleEditClick(vo)} className="mr-2" title="Bearbeiten" aria-label="Bearbeiten">
              <FaEdit />
            </Button>
            <Button variant="danger" onClick={(e) => handleDeleteClick(vo.id, e)} title="Löschen" aria-label="Löschen">
              <FaTrash />
            </Button>
          </ButtonGroup>
        ) : (
          <span>Keine Aktionen erlaubt</span> // Optionally display "No Actions" for IDs <= 10
        )}
      </td>
    </tr>
  ))}
</tbody>

      </Table>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />

        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>
      {/* Create Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Benutzerrolle erstellen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateSubmit}>
            <Form.Group controlId="formAreaGroupName">
              <Form.Label>Benutzerrollenname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Namen der Benutzerrolle eingeben"
                name="name"
                value={formData.name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

           
            <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
             {loading ? 'Wird gespeichert...' : 'Benutzerrolle speichern'}
             
            </Button>


            
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Benutzerrolle bearbeiten</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
          <Form.Group controlId="formAreaGroupName">
              <Form.Label>Benutzerrollenname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Benutzernamen eingeben"
                name="name"
                value={formData.name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3"disabled={loading}>
            {loading ? 'Wird aktualisiert...' : 'Rollengruppe aktualisieren'}
            
            </Button> 

           
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default BoardRoles;